import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './utils/variables.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

function setHeaderHeightVar() {
  const headerEl = document.querySelector('.cbp_layout_header');
  const h = headerEl ? headerEl.getBoundingClientRect().height : 0;
  document.documentElement.style.setProperty('--header-h', `${Math.round(h)}px`);
}
setHeaderHeightVar();
let __hh_t = null;
window.addEventListener('resize', () => {
  clearTimeout(__hh_t);
  __hh_t = setTimeout(setHeaderHeightVar, 150);
});

reportWebVitals();
